import { render, staticRenderFns } from "./VerifyPassSlipPage.vue?vue&type=template&id=2cfa736c&scoped=true"
import script from "./VerifyPassSlipPage.vue?vue&type=script&lang=js"
export * from "./VerifyPassSlipPage.vue?vue&type=script&lang=js"
import style0 from "./VerifyPassSlipPage.vue?vue&type=style&index=0&id=2cfa736c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa736c",
  null
  
)

export default component.exports